<template>
  <div>
    <wc-page-title title='Select Template'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='6'>
          <v-expansion-panels inset class='mb-5'>
            <v-expansion-panel v-for='t in templates' :key='t.id' @click='getRoutes(t)'>
              <v-expansion-panel-header>
                <span class='headline'>{{ t.name }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card outlined v-for='r in schItems' :key='r.id'>
                  <v-card-text>{{ r.route_obj.description }}</v-card-text>
                  <v-card-actions>
                    <v-btn text color='info' @click='openRouteQuickview(r.route_obj)'>View Route</v-btn>
                  </v-card-actions>
                </v-card>
                <br>
                <v-btn
                  depressed
                  block
                  color='primary'
                  :to="{ name: 'SetupRoutes', params: { id: t.id } }"
                >Use this template</v-btn>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          
          <v-btn
            class='mt-5'
            :to="{ name: 'SnowTrackerDashboard' }"
            depressed
            color='info'
          >
            Back to Tracker
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <route-quick-view
      :route='routeQuickView'
      :showDialog='showQuickView'
      @cancel='showQuickView = false'
    ></route-quick-view>
  </div>
</template>

<script>
import scheduleAPI from '@/modules/schedule/api/schedule'
import RouteQuickView from '@/modules/schedule/components/RouteQuickView'

export default {
  name: 'assign-routes',
  data: () => ({
    isLoading: false,
    gettingRoutes: true,
    showQuickView: false,
    templates: [],
    schItems: [],
    routeQuickView: {}
  }),
  mounted () {
    this.getTemplates()
  },
  methods: {
    async getTemplates () {
      this.isLoading = true
      this.templates = await scheduleAPI.getScheduleTemplates()
      this.isLoading = false
    },
    async getRoutes (sch) {
      // for a give "sch" (schedule) template, get all the connected routes
      this.gettingRoutes = true
      this.schItems = await scheduleAPI.getScheduleItemsForSchedule(sch.id)
      this.gettingRoutes = false
    },
    openRouteQuickview (route) {
      this.routeQuickView = route
      this.showQuickView = true
    }
  },
  components: {
    'route-quick-view': RouteQuickView
  }
}
</script>
